import React, { useState } from "react";
import { Button, Typography, TextField, IconButton } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import styled from "styled-components";
import parse from "html-react-parser";
import * as Scroll from "react-scroll";
import ReCAPTCHA from "react-google-recaptcha";
import { useSnackbar } from "notistack";
import { postFormApp } from "../../services";
import { Icons } from "../../components";

const Element = Scroll.Element;
const scroller = Scroll.scroller;

const StyledWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledWrapContent = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #d4d4d4;
`;

const StyledIcon = styled.div`
  cursor: pointer;
  padding-top: 5px;
`;

const StyledTitle = styled.div`
  margin-left: 24px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
`;

const StyledBody = styled.div`
  padding-bottom: 32px;
  border-bottom: 1px solid #d4d4d4;
`;

const StyledForm = styled.form`
  @media screen and (min-width: 500px) {
    max-width: 70%;
  }
  margin-top: 8px;
  padding: 24px;
`;

const initForm = {
  id: "",
  id_content: "",
  email: "",
  cv: "",
  hp: "",
  firstName: "",
  lastName: "",
  hyperlink: [""],
  isVerified: false,
};

const DetailLoker = ({ isId, onHandleBack, dataLoker }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState<any>(initForm);
  const [applyNowState, setApplyNowState] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const {
    sub_title_id,
    sub_title_en,
    place,
    contract,
    content_id,
    content_en,
  } = dataLoker;
  const subTitle = `${place} | ${contract}`;

  const handleAddPelamar = async (e: any) => {
    e.preventDefault();
    const body = new FormData();
    body.append("cv", formState.cv);
    body.append("id_content", dataLoker.id);
    body.append("fullname", `${formState.firstName} ${formState.lastName}`);
    body.append("email", formState.email);
    body.append("hp", formState.hp);
    body.append("type_form", "1");
    body.append("hyperlink", formState.hyperlink.join(","));
    try {
      setLoadingState(true);
      const res = await postFormApp(body);
      setLoadingState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar(`Berhasil mengirimkan data`, {
        variant: "success",
      });
      setFormState(initForm);
    } catch (err: any) {
      setLoadingState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const handleChange = (event: any, i: any = null) => {
    if (i || i === 0) {
      const currentHyperlink = formState.hyperlink;
      currentHyperlink[i] = event.target.value;
      setFormState({ ...formState, hyperlink: currentHyperlink });
    } else if (event.target.name === "cv") {
      setFormState({ ...formState, cv: event.target.files[0] });
    } else {
      setFormState({ ...formState, [event.target.name]: event.target.value });
    }
  };

  const handleAddHyperlink = () => {
    const currentHyperlink = formState.hyperlink;
    currentHyperlink.push("");
    setFormState({
      ...formState,
      hyperlink: currentHyperlink,
    });
  };

  const handleRemoveHyperlink = (index: any) => {
    const currentHyperlink = formState.hyperlink;
    currentHyperlink.splice(index, 1);
    setFormState({
      ...formState,
      hyperlink: currentHyperlink,
    });
  };

  return (
    <StyledWrap>
      <StyledWrapContent>
        <StyledHeader>
          <StyledIcon onClick={onHandleBack}>
            <Icons.IconBack height={25} width={25} />
          </StyledIcon>
          <StyledTitle>
            <Typography variant="h5" color="primary">
              {isId ? sub_title_id : sub_title_en}
            </Typography>
            <Typography color="textPrimary">{subTitle}</Typography>
          </StyledTitle>
          <StyledButton>
            <Button
              variant="contained"
              color="primary"
              disabled={applyNowState}
              onClick={() => {
                setApplyNowState(true);
                scroller.scrollTo("form-karir", {
                  smooth: true,
                  duration: 500,
                });
              }}
            >
              {isId ? "Daftar Sekarang" : "Apply Now"}
            </Button>
          </StyledButton>
        </StyledHeader>
        <StyledBody>
          <div id="content" style={{ marginTop: "2rem" }}>
            {parse(isId ? content_id : content_en)}
          </div>
        </StyledBody>
        <Element name="form-karir">
          {applyNowState && (
            <StyledForm onSubmit={handleAddPelamar}>
              <Typography
                variant="h5"
                color="primary"
                style={{ marginBottom: "2rem", fontWeight: 500 }}
              >
                {isId ? "Kirimkan Lamaranmu" : "Submit Your Application"}
              </Typography>

              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  gap: 16,
                }}
              >
                <TextField
                  onChange={handleChange}
                  value={formState.firstName}
                  name="firstName"
                  label={isId ? "Nama Depan" : "First Name"}
                  variant="outlined"
                  fullWidth
                  required
                />
                <TextField
                  onChange={handleChange}
                  value={formState.lastName}
                  name="lastName"
                  label={isId ? "Nama Belakang" : "Last Name"}
                  variant="outlined"
                  fullWidth
                  required
                />
              </div>

              <TextField
                onChange={handleChange}
                value={formState.email}
                type="email"
                name="email"
                label="E-mail"
                variant="outlined"
                fullWidth
                required
                style={{ marginBottom: "1rem" }}
              />
              <TextField
                onChange={handleChange}
                value={formState.hp}
                type="number"
                name="hp"
                label="No. Handphone"
                variant="outlined"
                fullWidth
                required
                style={{ marginBottom: "2rem" }}
              />
              <Typography style={{ fontWeight: 600 }}>
                Social Network and Web Links
              </Typography>
              <Typography
                color="textSecondary"
                style={{ marginBottom: "1rem" }}
              >
                Provide us with links to see some of your work (Git/ Dribble/
                Behance/ Pinterest/ Blog/ Medium)
              </Typography>
              {formState.hyperlink.map((text: string, i: number) => {
                const lastHyperlink = formState.hyperlink.length - 1;
                return (
                  <div
                    style={{
                      marginBottom: "1rem",
                      display: "flex",
                      gap: 16,
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      onChange={(e) => handleChange(e, i)}
                      value={text}
                      name="hyperlink"
                      label={isId ? "Hyperlink" : "Hyperlink"}
                      variant="outlined"
                      fullWidth
                      required
                    />
                    <div
                      onClick={() => {
                        if (lastHyperlink === i) {
                          handleAddHyperlink();
                        } else {
                          handleRemoveHyperlink(i);
                        }
                      }}
                      style={{
                        padding: 10,
                        backgroundColor: "#e3232a",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    >
                      <IconButton aria-label="add" size="small">
                        {lastHyperlink === i ? (
                          <Add style={{ color: "#fff" }} />
                        ) : (
                          <Delete style={{ color: "#fff" }} />
                        )}
                      </IconButton>
                    </div>
                  </div>
                );
              })}
              <div
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: 4,
                  padding: 16,
                  marginBottom: 16,
                }}
              >
                <Typography style={{ fontWeight: 600 }} gutterBottom>
                  CV
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Button
                    startIcon={<Add />}
                    style={{ backgroundColor: "#e1e2e1" }}
                    component="label"
                  >
                    Add CV
                    <input
                      type="file"
                      name="cv"
                      onChange={handleChange}
                      hidden
                    />
                  </Button>
                  {formState.cv && <Typography>{formState.cv.name}</Typography>}
                </div>
              </div>
              <ReCAPTCHA
                style={{ marginBottom: "1rem" }}
                sitekey="6LePYXgeAAAAAJc3IdiwIrPSFJgGPEo9bqzxiB9t"
                onChange={() =>
                  setFormState({ ...formState, isVerified: true })
                }
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loadingState || !formState.isVerified}
                size="large"
              >
                {loadingState ? "Loading" : isId ? "Kirim" : "Send"}
              </Button>
            </StyledForm>
          )}
        </Element>
      </StyledWrapContent>
    </StyledWrap>
  );
};

export default DetailLoker;
